import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { WishlistRepositoryImpl } from "../../domain/wishlistRepositoryImpl/WishlistRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const wishlistRepo = WishlistRepositoryImpl.getInstance();

const useRemoveVariantFromWishlist = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: async (variantId: string) => {
        return wishlistRepo.removeVariant(auth, variantId, apiUrl);
      },
    },
    queryClient,
  );

  const removeVariantFromWishlist = useCallback(
    (variantId: string, onSuccess: () => void, onError?: (error: unknown) => void) =>
      mutation.mutate(variantId, { onSuccess, onError }),
    [mutation],
  );

  return removeVariantFromWishlist;
};

export { useRemoveVariantFromWishlist };
